"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function StatesInTerritory({ statesInTerritory }) {
    const normalizedResults = statesInTerritory.reduce((result, item) => {
        const existingCountry = result.find((element) => element.country.id === item.country.id);
        if (existingCountry) {
            existingCountry.states.push({ id: item.id, name: item.name });
        }
        else {
            result.push({
                country: { id: item.country.id, name: item.country.name },
                states: [{ id: item.id, name: item.name }],
            });
        }
        return result;
    }, []);
    normalizedResults.sort((a, b) => {
        return a.country.name.localeCompare(b.country.name);
    });
    normalizedResults.forEach((item) => {
        item.states.sort((x, y) => {
            return x.name.localeCompare(y.name);
        });
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, normalizedResults.map((item, index) => {
        return (react_1.default.createElement("div", { key: item.country.id },
            react_1.default.createElement("div", null,
                item.country.name,
                ": ",
                item.states.map((state) => state.name).join(', '))));
    })));
}
exports.default = StatesInTerritory;
